"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWalletAdapters = useWalletAdapters;
var react_1 = require("react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var solana_headless_adapter_base_1 = require("@hermis/solana-headless-adapter-base");
var useWallet_1 = require("./useWallet");
/**
 * Hook for working with wallet adapters, including sorting and filtering
 *
 * @returns Object with grouped and sorted wallet adapters
 */
function useWalletAdapters() {
    var wallets = (0, useWallet_1.useWallet)().wallets;
    return (0, react_1.useMemo)(function () {
        var adapters = wallets.map(function (wallet) { return wallet.adapter; });
        var sortedAdapters = (0, solana_headless_adapter_base_1.sortWalletAdapters)(adapters);
        var installed = (0, solana_headless_adapter_base_1.getAdaptersByReadyState)(sortedAdapters, solana_headless_core_1.WalletReadyState.Installed);
        var loadable = (0, solana_headless_adapter_base_1.getAdaptersByReadyState)(sortedAdapters, solana_headless_core_1.WalletReadyState.Loadable);
        var notDetected = (0, solana_headless_adapter_base_1.getAdaptersByReadyState)(sortedAdapters, solana_headless_core_1.WalletReadyState.NotDetected);
        return {
            installed: installed,
            loadable: loadable,
            notDetected: notDetected,
            all: sortedAdapters
        };
    }, [wallets]);
}
